import { DEVICE } from "./config";

let deferredPrompt = null;

// Register PWA application and install prompt
if (['WEB', 'PWA'].includes(DEVICE)) {
    window.addEventListener('beforeinstallprompt', (e) => {
        deferredPrompt = e;
    });

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/sw.js', {
                scope: '/'
            }).catch((err) => {
                // Service worker registration can fail for reasons outside our
                // control (flaky networks, proxies, bots, blocking extensions,
                // transient CDN errors). Swallow the rejection so it does not
                // surface as an unhandled promise rejection in Sentry.
                console.warn('Service worker registration failed', err);
            });
        });
    }
}

export const isPWAInstallAvailable = () => {
    return DEVICE === 'WEB' && deferredPrompt !== null
}

export const triggerPWAInstall = async () => {
    if (deferredPrompt !== null) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
            deferredPrompt = null;
        }
    }
}
